module.exports = __webpack_public_path__ + "img/renegades_8ko.cad1113.jpg";